// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-icon[data-v-b37ebfee] {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  background-size: 100%;\n  vertical-align: bottom;\n}\n", ""]);
// Exports
module.exports = exports;
